import type { BundleContext } from './BundleContext.js';
import type { BundleOptions } from './BundleOptions.js';
import type { BundlerResult } from './BundlerResult.js';

/**
 * This is the interface wrapping each bundler implementation.
 */
export interface Bundler {
  /** Friendly name of the underlying bundler */
  name: string;
  /** Version of the underlying bundler package */
  version: string | Promise<string>;
  bundle: (options: BundleOptions, context: BundleContext) => Promise<BundlerResult>;
}
